module.exports = __webpack_public_path__ + "img/imtoken.c3896985.svg";